import { ICondition } from "../State";

export default class CombinedCondition implements ICondition {
    protected conditionList: ICondition[];
    protected type: ConditionCombinationType

    constructor(conditions: ICondition[], type: ConditionCombinationType = ConditionCombinationType.ALL) {
        this.conditionList = conditions;
        this.type = type;

    }

    check(): boolean {
        let final = false;
        let conditionMet = this.type === ConditionCombinationType.ALL ;
        this.conditionList.forEach(condition => {
            let current = condition.check();
            switch(this.type) {
                case ConditionCombinationType.ALL:
                    conditionMet = current && conditionMet;
                    final = conditionMet;
                    break;
                case ConditionCombinationType.ANY:
                    conditionMet = current || conditionMet;
                    final = conditionMet;
                break;
                case ConditionCombinationType.NON:
                    conditionMet = current && conditionMet;
                    final = !(current && conditionMet);
                break;
            }
        });

        return conditionMet || final ;
    }

}

export enum ConditionCombinationType {
    ALL = "ALL",
    ANY = "ANY",
    NON = "NON"
}